<template>
<div>

  <div v-if="!spinner" class="form-group">
  <label for="fornitore"><strong>FORNITORE</strong></label>
    <select id="supplier" required :disabled="!isActive" @change="$emit('update',supplierId)" class="form-control" v-model="supplierId" >
      <option v-if="optionBase==true" value="0"> -- Seleziona un fornitore -- </option> 
      <option v-for="(item,index) in items" :value="item.supplierId" :key="index">{{item.supplier}}</option>        
    </select>
    <small v-if="small">Selezionare un fornitore dall'elenco</small>  
  </div>
  <div v-else>
      <div class="spinner-border spinner-border-sm" role="status">
          <span class="sr-only">Loading...</span>
      </div>
  </div>    

</div>
</template>

<script>
import api              from "@/api";
import { mapGetters }   from 'vuex';
export default {
  props : ['isActive','optionBase','Id','small'] , 
  components: {},
  data() {
    return {

      supplierId             : 0,
      items                  : [],
      spinner                : false


     
    };
  },
  mounted: function() {
    
  },
   computed: 
  {  
    ...mapGetters(['company']),
  },  
  created: function() {
      this.getData()
     // console.log(this.Id)
  },
  methods: 
  {
    async getData()
    {
      
      this.spinner = true
      var sp   = {'sp'  : 'spSupplierSelect'}  
      var data   = {'companyId':this.company.Id}
      var json     = Object.assign(data, sp)    
        await api.post(json).then(res => {                   
          if(res.status==200)
            {
              this.items = res.data.recordsets[0]   
              this.supplierId = this.Id      
                         
            }
           else if(res.status==500)
           {
                console.log(res.data)                
                    
           } 
           else
            {
                
                console.log('Network Error.')                  
                 
            } 
          

          }).catch(err => {
              
              console.log(err.message)    

              
          }).finally(() => {
          this.spinner = false
        });


    },
      
  
}

}
</script>
<style scoped>

</style>